module.exports = __webpack_public_path__ + "img/bg-proyectos-5.e6af2278.png";